/** Static preview data until GET /api/v1/challenges/hub is live */

export const MISSIONS_MOCK_HEADER = {
  playerName: "Dennis",
  activeCount: 8,
  readyToClaim: 2,
  fsThisWeek: 145,
  streakDays: 4,
};

export const MISSIONS_MOCK_STREAK = {
  currentDays: 4,
  targetDays: 7,
  pct: 0.571,
  todayReward: "20 FS",
  megaPrizeLabel: "100 FS",
  daysToMega: 3,
};

export const MISSIONS_MOCK_CLAIMS = [
  { avatar: "L", who: "L***a", what: "Sweet Bonanza 547× — chasing 1,000×", amt: "427×" },
  { avatar: "M", who: "M***o T", what: "Crash Triple completed", amt: "60 FS" },
  { avatar: "K", who: "K. O***u", what: "Bonus Buy Hunter completed", amt: "100 FS" },
  { avatar: "D", who: "D. P***v", what: "$500 Wagered claimed", amt: "300 FS" },
  { avatar: "S", who: "S. N***n", what: "Megaways Marathon", amt: "50 FS" },
  { avatar: "R", who: "R***l F", what: "Red Hot Streak — live roulette", amt: "75 FS" },
  { avatar: "T", who: "T***k", what: "Provider Pioneer (5/5)", amt: "25 FS" },
  { avatar: "J", who: "J. V***i", what: "3-in-a-Row streak", amt: "20 FS" },
];

export const CHALLENGE_DETAILS = {
  "1000x-hunter": {
    artBg:
      "radial-gradient(360px 240px at 70% 50%,#e055a0,transparent 60%),linear-gradient(140deg,#a8408a,#3a0c2a)",
    game: "Sweet Bonanza",
    tier: "diamond",
    tierLabel: "◆ Diamond · Communal",
    time: "⏱ 2d 13h",
    timeUrgent: false,
    title: "1,000× Hunter",
    desc:
      "Be the <b>first player</b> to hit a single-spin multiplier of <b>1,000×</b> or higher on Sweet Bonanza with a minimum <b>€0.40</b> bet. Communal challenge — only one winner.",
    progLabel: "Your personal best",
    progValue: "427× / 1,000×",
    progPct: 42.7,
    rewards: [
      { icon: "🌀", amount: "500", unit: "FS" },
      { icon: "🍀", amount: "1,000", unit: "CC" },
    ],
    tip: "Sweet Bonanza's biggest multipliers drop during the bonus round.",
    cta: "Play Sweet Bonanza",
    locked: false,
  },
  "bonus-buy-hunter": {
    artBg:
      "radial-gradient(320px 220px at 70% 50%,#c95a1d,transparent 60%),linear-gradient(140deg,#8a3a1d,#3a1a0c)",
    game: "Le Bandit",
    tier: "silver",
    tierLabel: "● Silver · Ready",
    time: "✓ Ready to claim",
    timeUrgent: false,
    title: "Bonus Buy Hunter",
    desc: "Trigger the bonus round on Le Bandit <b>5 times</b> this week. You did it — tap claim.",
    progLabel: "Progress",
    progValue: "5 / 5",
    progPct: 100,
    progDone: true,
    rewards: [{ icon: "🌀", amount: "100", unit: "FS" }],
    tip: "Use the bonus-buy button to skip straight to the feature.",
    cta: "Claim 100 FS",
    locked: false,
  },
  "first-2000x": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#caa01d,transparent 60%),linear-gradient(140deg,#7a6e1d,#3a340c)",
    game: "Gates of Olympus",
    tier: "diamond",
    tierLabel: "◆ Diamond · Communal",
    time: "⚡ 4h left",
    timeUrgent: true,
    title: "First to 2,000×",
    desc:
      "<b>First player</b> to hit a 2,000× single-spin multiplier on Gates of Olympus (min $0.20 bet). Communal — winner takes all.",
    progLabel: "Top so far",
    progValue: "1,108× / 2,000×",
    progPct: 55,
    rewards: [{ icon: "🌀", amount: "500", unit: "FS" }],
    tip: "Zeus's multiplier orbs stack inside the bonus round.",
    cta: "Play Gates of Olympus",
    locked: false,
  },
  "wager-warrior": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#2bd065,transparent 60%),linear-gradient(140deg,#1d6e3a,#0c3a1e)",
    game: "Any qualifying game",
    tier: "diamond",
    tierLabel: "◆ Diamond · Personal",
    time: "⏱ 3d left",
    timeUrgent: false,
    title: "$500 Wagered This Week",
    desc: "Wager a total of <b>$500</b> across any qualifying game this week.",
    progLabel: "Wagered",
    progValue: "$387 / $500",
    progPct: 77.4,
    rewards: [
      { icon: "🌀", amount: "300", unit: "FS" },
      { icon: "🍀", amount: "500", unit: "CC" },
    ],
    tip: "Stack this with the Weekly Race — every $1 wagered also earns 1 Clover Coin.",
    cta: "Play any game",
    locked: false,
  },
  "provider-pioneer": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#1d8aca,transparent 60%),linear-gradient(140deg,#1d5a7a,#0c2a3a)",
    game: "Provider Hunt",
    tier: "bronze",
    tierLabel: "● Bronze · Daily",
    time: "⏱ 23h left",
    timeUrgent: false,
    title: "Provider Pioneer",
    desc: "Play at least one round on <b>5 different game providers</b> today.",
    progLabel: "Providers played",
    progValue: "3 / 5",
    progPct: 60,
    rewards: [{ icon: "🌀", amount: "25", unit: "FS" }],
    tip: "Open the Providers menu and spin once on each.",
    cta: "Browse providers",
    locked: false,
  },
  "crash-triple": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#a8408a,transparent 60%),linear-gradient(140deg,#6e1d5a,#3a0c2a)",
    game: "Aviator / Crash",
    tier: "silver",
    tierLabel: "● Silver · Today only",
    time: "⚡ today only",
    timeUrgent: true,
    title: "Crash Cash-Out Triple",
    desc: "Cash out at <b>10× or higher</b> on any crash game <b>three times</b> today.",
    progLabel: "Cash-outs",
    progValue: "2 / 3",
    progPct: 66.7,
    rewards: [{ icon: "🌀", amount: "60", unit: "FS" }],
    tip: "Set your auto-cashout to 10.00× and keep launching small bets.",
    cta: "Play Aviator",
    locked: false,
  },
  "megaways-marathon": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#1dbd8a,transparent 60%),linear-gradient(140deg,#1d7a5a,#0c3a2a)",
    game: "Any Megaways slot",
    tier: "silver",
    tierLabel: "● Silver · Ready",
    time: "✓ Ready to claim",
    timeUrgent: false,
    title: "Megaways Marathon",
    desc: "Spin <b>100 rounds</b> on any Megaways title — claim your reward.",
    progLabel: "Spins",
    progValue: "100 / 100",
    progPct: 100,
    progDone: true,
    rewards: [{ icon: "🌀", amount: "50", unit: "FS" }],
    tip: "Tap Claim and your free spins land within 60 seconds.",
    cta: "Claim 50 FS",
    locked: false,
  },
  "three-in-row": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#e08a20,transparent 60%),linear-gradient(140deg,#a05a20,#3a1a00)",
    game: "Any slot",
    tier: "bronze",
    tierLabel: "● Bronze · Today",
    time: "⚡ 3h left",
    timeUrgent: true,
    title: "3-in-a-Row",
    desc: "Win <b>3 consecutive spins</b> on any slot today.",
    progLabel: "Streak",
    progValue: "1 / 3",
    progPct: 33,
    rewards: [{ icon: "🌀", amount: "20", unit: "FS" }],
    tip: "Try Sweet Bonanza or Sugar Rush where small wins are common.",
    cta: "Play any slot",
    locked: false,
  },
  "reel-in-750x": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#2050ca,transparent 60%),linear-gradient(140deg,#1d3a7a,#0c1a3a)",
    game: "Big Bass Bonanza",
    tier: "gold",
    tierLabel: "★ Gold · New",
    time: "⏱ 6d left",
    timeUrgent: false,
    title: "Reel In 750×",
    desc: "Hit a <b>single-spin multiplier of 750×</b> or higher on any Big Bass Bonanza title.",
    progLabel: "Best so far",
    progValue: "— / 750×",
    progPct: 0,
    rewards: [
      { icon: "🌀", amount: "150", unit: "FS" },
      { icon: "🍀", amount: "200", unit: "CC" },
    ],
    tip: "Bonanza, Splash, Hold & Spinner all qualify.",
    cta: "Play Big Bass",
    locked: false,
  },
  "red-hot-streak": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#a82a30,transparent 60%),linear-gradient(140deg,#5a1820,#2a0a0c)",
    game: "Live Roulette",
    tier: "gold",
    tierLabel: "★ Gold · Live",
    time: "⏱ 2d left",
    timeUrgent: false,
    title: "Red Hot Streak",
    desc: "Win <b>5 red bets in a row</b> on any Live Roulette table.",
    progLabel: "Best streak",
    progValue: "2 / 5",
    progPct: 40,
    rewards: [{ icon: "🌀", amount: "75", unit: "FS" }],
    tip: "Stick to small flat bets to keep the run going.",
    cta: "Play live roulette",
    locked: false,
  },
  "outlaws-bounty": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#c95a1d,transparent 60%),linear-gradient(140deg,#7a3a1d,#3a1a0c)",
    game: "Wanted Dead or Alive 2",
    tier: "gold",
    tierLabel: "★ Gold · New",
    time: "⏱ 6d left",
    timeUrgent: false,
    title: "Outlaw's Bounty",
    desc: "Trigger any of the <b>three bonus picks</b> on Wanted Dead or Alive 2 — <b>three times</b>.",
    progLabel: "Triggers",
    progValue: "— / 3",
    progPct: 0,
    rewards: [{ icon: "🌀", amount: "120", unit: "FS" }],
    tip: "Wanted DOA 2 is high-volatility — patient bankroll wins this one.",
    cta: "Play Wanted DOA 2",
    locked: false,
  },
  "vip-5k-spin": {
    artBg:
      "radial-gradient(340px 240px at 70% 50%,#5a3a8a,transparent 60%),linear-gradient(140deg,#3a2a4a,#1a0a2a)",
    game: "High Roller",
    tier: "gold",
    tierLabel: "★ Gold · VIP Locked",
    time: "🔒 VIP locked",
    timeUrgent: false,
    title: "$5,000 Single-Spin",
    desc:
      "Place a single spin of <b>$5,000 or more</b>. <b>Reach Diamond tier</b> in the VIP Club to unlock.",
    progLabel: "Your tier",
    progValue: "Emerald · 2 to Diamond",
    progPct: 0,
    rewards: [
      { icon: "🌀", amount: "1,000", unit: "FS" },
      { icon: "🍀", amount: "5,000", unit: "CC" },
    ],
    tip: "Climb to Diamond tier by earning VIP XP.",
    cta: "View VIP Club",
    locked: true,
  },
};

export const MISSION_LOG_ITEMS = [
  {
    cid: "bonus-buy-hunter",
    state: "claim",
    artBg: "linear-gradient(140deg,#8a3a1d,#3a1a0c)",
    artLabel: "Le Bandit",
    tier: "silver",
    title: "Bonus Buy Hunter",
    description: "Trigger 5 bonus rounds — complete",
    progPct: 100,
    progLabel: "100%",
    progDone: true,
    rewards: [{ icon: "🌀", amount: "100", unit: "FS" }],
    rewardSmall: "Ready",
    time: null,
    timeUrgent: false,
  },
  {
    cid: "1000x-hunter",
    state: "active",
    selected: true,
    artBg: "linear-gradient(140deg,#a8408a,#3a0c2a)",
    artLabel: "Sweet Bonanza",
    tier: "diamond",
    title: "1,000× Hunter",
    description: "First to hit a 1,000× single-spin multiplier",
    progPct: 42.7,
    progLabel: "43%",
    rewards: [
      { icon: "🌀", amount: "500", unit: "FS" },
      { icon: "🍀", amount: "1,000", unit: "CC" },
    ],
    rewardSmall: "Reward",
    time: "2d 13h",
    timeUrgent: false,
  },
  {
    cid: "first-2000x",
    state: "active",
    artBg: "linear-gradient(140deg,#7a6e1d,#3a340c)",
    artLabel: "Olympus",
    tier: "diamond",
    title: "First to 2,000×",
    description: "Communal · winner takes all · top so far 1,108×",
    progPct: 55,
    progLabel: "55%",
    rewards: [{ icon: "🌀", amount: "500", unit: "FS" }],
    rewardSmall: "WTA",
    time: "⚡ 4h",
    timeUrgent: true,
  },
  {
    cid: "wager-warrior",
    state: "active",
    artBg: "linear-gradient(140deg,#1d6e3a,#0c3a1e)",
    artLabel: "Any game",
    tier: "diamond",
    title: "Wager Warrior · $500",
    description: "Wager $500 across any qualifying game this week",
    progPct: 77.4,
    progLabel: "77%",
    rewards: [
      { icon: "🌀", amount: "300", unit: "FS" },
      { icon: "🍀", amount: "500", unit: "CC" },
    ],
    rewardSmall: "Reward",
    time: "3d",
    timeUrgent: false,
  },
  {
    cid: "provider-pioneer",
    state: "active",
    artBg: "linear-gradient(140deg,#1d5a7a,#0c2a3a)",
    artLabel: "Provider",
    tier: "bronze",
    title: "Provider Pioneer",
    description: "Play at least one round on 5 providers today",
    progPct: 60,
    progLabel: "3/5",
    rewards: [{ icon: "🌀", amount: "25", unit: "FS" }],
    rewardSmall: "Reward",
    time: "23h",
    timeUrgent: false,
  },
  {
    cid: "crash-triple",
    state: "active",
    artBg: "linear-gradient(140deg,#6e1d5a,#3a0c2a)",
    artLabel: "Crash",
    tier: "silver",
    title: "Crash Cash-Out Triple",
    description: "Cash out at 10×+ three times today",
    progPct: 66,
    progLabel: "2/3",
    rewards: [{ icon: "🌀", amount: "60", unit: "FS" }],
    rewardSmall: "Reward",
    time: "⚡ today",
    timeUrgent: true,
  },
  {
    cid: "megaways-marathon",
    state: "claim",
    artBg: "linear-gradient(140deg,#1d7a5a,#0c3a2a)",
    artLabel: "Megaways",
    tier: "silver",
    title: "Megaways Marathon",
    description: "100 Megaways spins — done",
    progPct: 100,
    progLabel: "100%",
    progDone: true,
    rewards: [{ icon: "🌀", amount: "50", unit: "FS" }],
    rewardSmall: "Ready",
    time: null,
    timeUrgent: false,
  },
  {
    cid: "three-in-row",
    state: "active",
    artBg: "linear-gradient(140deg,#a05a20,#3a1a00)",
    artLabel: "Streak",
    tier: "bronze",
    title: "3-in-a-Row",
    description: "Win 3 consecutive spins on any slot today",
    progPct: 33,
    progLabel: "1/3",
    rewards: [{ icon: "🌀", amount: "20", unit: "FS" }],
    rewardSmall: "Reward",
    time: "⚡ 3h",
    timeUrgent: true,
  },
  {
    cid: "reel-in-750x",
    state: "new",
    artBg: "linear-gradient(140deg,#1d3a7a,#0c1a3a)",
    artLabel: "Big Bass",
    tier: "gold",
    title: "Reel In 750×",
    description: "Hit a 750× multiplier on Big Bass Bonanza",
    progPct: 0,
    progLabel: "New",
    rewards: [
      { icon: "🌀", amount: "150", unit: "FS" },
      { icon: "🍀", amount: "200", unit: "CC" },
    ],
    rewardSmall: "Reward",
    time: "6d",
    timeUrgent: false,
  },
  {
    cid: "red-hot-streak",
    state: "active",
    artBg: "linear-gradient(140deg,#5a1820,#2a0a0c)",
    artLabel: "Live Roulette",
    tier: "gold",
    title: "Red Hot Streak",
    description: "Win 5 red bets in a row on any live table",
    progPct: 40,
    progLabel: "2/5",
    rewards: [{ icon: "🌀", amount: "75", unit: "FS" }],
    rewardSmall: "Reward",
    time: "2d",
    timeUrgent: false,
  },
  {
    cid: "outlaws-bounty",
    state: "new",
    artBg: "linear-gradient(140deg,#7a3a1d,#3a1a0c)",
    artLabel: "DOA 2",
    tier: "gold",
    title: "Outlaw's Bounty",
    description: "Trigger any bonus pick 3 times on Wanted DOA 2",
    progPct: 0,
    progLabel: "New",
    rewards: [{ icon: "🌀", amount: "120", unit: "FS" }],
    rewardSmall: "Reward",
    time: "6d",
    timeUrgent: false,
  },
  {
    cid: "vip-5k-spin",
    state: "locked",
    artBg: "linear-gradient(140deg,#3a2a4a,#1a0a2a)",
    artLabel: "VIP",
    tier: "gold",
    title: "$5,000 Single-Spin",
    description: "Reach Diamond VIP to unlock this high-roller mission",
    progPct: 0,
    progLabel: "🔒",
    rewards: [
      { icon: "🌀", amount: "1,000", unit: "FS" },
      { icon: "🍀", amount: "5,000", unit: "CC" },
    ],
    rewardSmall: "Reward",
    time: "VIP",
    timeUrgent: false,
    locked: true,
  },
];

/** Weekly "Golden Clover" collection meta-loop (preview shape).
 *  Completing missions drops 1 of 4 leaf pieces, one per vertical; assembling
 *  all 4 before week-end forges a Golden Clover. `forgedThisSeason` feeds the
 *  season album on the Rewards page. Consumed by the 4-slot banner widget. */
export const MISSIONS_MOCK_CLOVER = {
  weekEndsLabel: "Sunday",
  collectedCount: 2,
  totalCount: 4,
  forgedThisSeason: 3,
  leaves: [
    { type: "slots", label: "Slots", collected: true },
    { type: "live", label: "Live", collected: true },
    { type: "sports", label: "Sports", collected: false },
    { type: "daily", label: "Daily Login", collected: false },
  ],
};

export const DEFAULT_SELECTED_CID = "1000x-hunter";

export function getMissionsMockState() {
  return {
    header: MISSIONS_MOCK_HEADER,
    streak: MISSIONS_MOCK_STREAK,
    claims: MISSIONS_MOCK_CLAIMS,
    clover: MISSIONS_MOCK_CLOVER,
    log: MISSION_LOG_ITEMS,
    challenges: CHALLENGE_DETAILS,
    selectedCid: DEFAULT_SELECTED_CID,
    isPreviewDemo: true,
  };
}
